import React from "react";

const MdmKeyValueTable = ({
  rows,
  stringifyForTableCell,
  formatDisplay = (raw) => raw,
  valueCellClassName = "break-words",
}) => {
  if (!rows.length) {
    return (
      <tr>
        <td className="px-3 py-2 text-on-surface-variant" colSpan={2}>
          No data
        </td>
      </tr>
    );
  }

  return rows.map(([key, value]) => {
    const raw = stringifyForTableCell(value);
    const display = formatDisplay(raw);
    return (
      <tr key={key}>
        <td className="px-3 py-2 font-mono text-[11px] text-on-surface-variant align-top whitespace-nowrap">
          {key}
        </td>
        <td className="px-3 py-2 align-top">
          <div
            className={`font-mono text-[11px] whitespace-pre-wrap ${valueCellClassName}`}
            title={raw}
          >
            {display}
          </div>
        </td>
      </tr>
    );
  });
};

export const MdmKeyValueTableWrapper = ({ children }) => (
  <div className="overflow-x-auto">
    <table className="min-w-full text-left text-xs border border-outline-variant/20 rounded-lg overflow-hidden">
      <thead className="bg-surface-container-low/50">
        <tr className="text-[10px] text-on-surface-variant uppercase tracking-wide">
          <th className="px-3 py-2 font-bold whitespace-nowrap">Key</th>
          <th className="px-3 py-2 font-bold">Value</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-outline-variant/20 bg-surface-container-high">{children}</tbody>
    </table>
  </div>
);

export default MdmKeyValueTable;
